// extracted by mini-css-extract-plugin
export default {"text":"ProgramTerdekat_text__z5-Pq","programItems":"ProgramTerdekat_programItems__V5agG","btnContainer":"ProgramTerdekat_btnContainer__P9f6J"};